import { render, staticRenderFns } from "./input-boards-dropdown.vue?vue&type=template&id=333abc14&"
import script from "./input-boards-dropdown.vue?vue&type=script&lang=js&"
export * from "./input-boards-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./input-boards-dropdown.vue?vue&type=style&index=0&id=333abc14&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports